// DOC REF {reportProgress: true, observe: "events"}
// https://blog.devgenius.io/file-upload-with-progress-bar-in-angular-13-76adb3380f18
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Resource } from '@models/resource/Resource';
import { Response } from '@models/response-api/ResponseApi';
import { ResourceUpload } from '@models/resource/Resource';
import * as saveAs from 'file-saver';
import { Content, MinifiedContent } from '@models/content/Content';

@Injectable({
	providedIn: 'root',
})
export class ResourceService {
	private url = `${environment.hostAPI}/resources`;

  constructor(private http: HttpClient) {}

  getByTeacher() {
    const url = `${this.url}/teacher`
    return this.http.get<Response>(url);
  }

  add(resource: ResourceUpload) {
    const {file, name, description, teacherResourceId} = resource;
    const url = `${this.url}/upload`;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);
    formData.append("description", description);
    formData.append("teacherResourceId", teacherResourceId.toString());
    return this.http.post<Response>(url, formData, {reportProgress: true, observe: "events"});
  }

  deleteResource(resource: Resource) {
    const url = `${this.url}?id=${resource.id}`
    return this.http.delete<Response>(url);
  }

  downloadResource(resource: Resource) {
    const url = `${this.url}/download/${resource.id}`
    var array = resource.url.split('?sv=');
    var urlRes = array[0];
    var arrayFileType = urlRes.split('.');
    var fileExtension = arrayFileType[arrayFileType.length - 1];
    
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (response: Blob) => {
        const file = new Blob([response], { type: response.type });

        saveAs(file, resource.name + '.' + fileExtension);        
      },
      (error: any) => {
        console.error('Failed to download file', error);
      }
    );
  }

  downloadContent(resource: MinifiedContent | Content) {
    const url = `${environment.hostAPI}/contents/${resource.id}/download`;
    var array = resource.urlContent.split('?sv=');
    var urlRes = array[0];
    var arrayFileType = urlRes.split('.');
    var fileExtension = arrayFileType[arrayFileType.length - 1];
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (response: Blob) => {
        const file = new Blob([response], { type: response.type });

        saveAs(file, resource.name + '.' + fileExtension);        
      },
      (error: any) => {
        console.error('Failed to download file', error);
      }
    );
  }
}
